'use client';

import React from 'react';
import { HeroPageHeader } from '../../_components/LayoutPageHeader/HeroPageHeader';
import { VideoCategoryKey, WATCH_CANONICAL, WATCH_DESCRIPTION, WATCH_TITLE } from './utils';
import styles from './WatchPageHeader.module.scss';

const WATCH_BREADCRUMBS = [
  { href: '/', id: 'home', name: 'Home' },
  { href: '/watch', id: 'watch', name: 'Watch' },
];

interface WatchPageHeaderProps {
  activeCategory: VideoCategoryKey;
  categories: VideoCategoryKey[];
  onCategoryChange: (category: VideoCategoryKey) => void;
  videoCount: number;
}

export function WatchPageHeader({
  activeCategory,
  categories,
  onCategoryChange,
  videoCount,
}: WatchPageHeaderProps) {
  const tabs =
    categories.length > 1
      ? categories.map(category => ({
          id: category,
          isActive: activeCategory === category,
          label: category,
          onSelect: () => onCategoryChange(category),
        }))
      : [];
  const videoCountLabel = (
    <span className="mt-2 block text-[13px] font-semibold whitespace-nowrap text-[#9fb3c8] tabular-nums leading-snug md:text-[15px]">
      {videoCount} {videoCount === 1 ? 'video' : 'videos'}
    </span>
  );

  return (
    <HeroPageHeader
      breadcrumbs={WATCH_BREADCRUMBS}
      buttonLocation="watch_page"
      canonical={WATCH_CANONICAL}
      className={styles.watchHeader}
      description={WATCH_DESCRIPTION}
      descriptionFooter={videoCountLabel}
      navAriaLabel="Video categories"
      tabs={tabs}
      title={WATCH_TITLE}
    />
  );
}
